"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.agent.speaking': '代理正在说话',
    'conversation.agent.thinking': '代理正在思考...',
    'conversation.agent.demo': '语音代理演示',
    'conversation.agent.demo.description': '使用先进语音识别和合成技术与AI代理进行交互式语音对话',
};
